import { useEffect } from "react";

// Docs pages are served at a trailing slash by nginx; canonical + og:url must
// match that 200 URL (not the /docs/x -> /docs/x/ redirect). Mirrors docUrl() in
// scripts/docs-lib.mjs so client-rendered heads agree with the prerendered ones.
const canonicalHref = (path) => `https://voleor.com${path}${path.endsWith("/") ? "" : "/"}`;

const upsertMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const initial = {
  title: typeof document !== "undefined" ? document.title : "",
  description: typeof document !== "undefined"
    ? document.head.querySelector('meta[name="description"]')?.getAttribute("content") || ""
    : "",
};

// Client-side head for SPA navigation. Crawler-facing head comes from prerendered HTML.
export default function useDocHead({ title, description, path, noindex = false }) {
  useEffect(() => {
    document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", canonicalHref(path));
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", canonicalHref(path));
    let robots = document.head.querySelector('meta[name="robots"][data-docs]');
    if (noindex) {
      if (!robots) {
        robots = document.createElement("meta");
        robots.setAttribute("name", "robots");
        robots.setAttribute("data-docs", "1");
        document.head.appendChild(robots);
      }
      robots.setAttribute("content", "noindex");
    } else if (robots) robots.remove();
    return () => {
      document.title = initial.title;
      upsertMeta("name", "description", initial.description);
      canonical?.setAttribute("href", "https://voleor.com/");
      document.head.querySelector('meta[name="robots"][data-docs]')?.remove();
    };
  }, [title, description, path, noindex]);
}
